import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MunicipalitiesService } from '../municipalities.service';

@Component({
  selector: 'app-display-municipality',
  templateUrl: './display-municipality.component.html',
  styleUrls: ['./display-municipality.component.scss']
})
export class DisplayMunicipalityComponent implements OnInit {
  dataToDisplay
  municipalityInfo

  constructor(
    private route: ActivatedRoute,
    private municipalitiesService: MunicipalitiesService
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');

      this.getMunicipalityById(id);



    });




  }



  getMunicipalityById(id: string) {
    return this.municipalitiesService.getMunicipalityById(id).subscribe(
      data => {
        console.log("data_________________ getMunicipalityById");
        console.log(data);
        this.municipalityInfo = data;

      }
    )
  }

}
